import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin as MotionPath } from "gsap/MotionPathPlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MotionPath);

const context = '.page-template-template-champagne section:not(.hero)';

if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let bottleArray = gsap.utils.toArray([`${context} .container img.bottle`]);
    let textArray = gsap.utils.toArray([`${context} h3`, `${context} p`, `${context} button`]);
    let decorationArray = gsap.utils.toArray([`${context} .parallax-background img.decoraz`]);
    let apiOddArray = gsap.utils.toArray([`${context} .full-container:nth-child(odd) .parallax-background img.free-ape`]);
    let apiEvenArray = gsap.utils.toArray([`${context} .full-container:nth-child(even) .parallax-background img.free-ape`]);


    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;

        apiOddArray.forEach(el => {
            let apiOddTl = gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    end: "bottom top",
                    invalidateOnRefresh: true,
                    scrub: true,
                },
                motionPath: {
                    path: [{x:0, y:0}, {x:-200, y:120}, {x:-120, y:380}, {x:-350, y:450}],
                    align: "self",
                    alignOrigin: [0.5, 0.5],
                    autoRotate: true,
                    type: "cubic"
                }
            });
        });

        apiEvenArray.forEach(el => {
            let apiEvenTl = gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    end: "bottom top",
                    invalidateOnRefresh: true,
                    scrub: true,
                },
                motionPath: {
                    path: [{x:0, y:0}, {x:300, y:120}, {x:200, y:380}, {x:350, y:450}],
                    align: "self",
                    alignOrigin: [0.5, 0.5],
                    autoRotate: true,
                    type: "cubic"
                }
            });
        });
        
        bottleArray.forEach(el => {
            let bottleTl = gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    end: "bottom top",
                    invalidateOnRefresh: true,
                    scrub: true,
                },
                scale: 1.2
            });
        });
    
        textArray.forEach(text => {
            let textTl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                }
            });
            textTl.from(text, {opacity: 0, duration: 1, y: 20});
        });
    
        decorationArray.forEach((decoration, index) => {
            let decorationTl = gsap.timeline({
                scrollTrigger: {
                    trigger: decoration,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                }
            });
            if (index % 2 === 0) {
                decorationTl.from(decoration, {opacity: 0.2, x:"+=50", duration: 1});
            } else {
                decorationTl.from(decoration, {opacity: 0.2, x:"-=50", duration: 1});
            }
        });
    });


    

}